import React, { useEffect, useState } from "react";
import { ControlLabel, FormControl, FormGroup } from "react-bootstrap";
import HelpHintButton from "components/HelpHintButton";
import { THEME_FONT } from "../constants";
import { getFonts } from "../../../../../api/cp";

const STANDART_FONT = 'Стандартный';

const FontSettings = ({ font, onUpdate }) => {
    const [fontsList, setFontsList] = useState([]);

    useEffect(() => {
        getFontsList();
    }, []);

    async function getFontsList() {
        try {
            const data = await getFonts();

            setFontsList(data?.sort((a, b) => !!b.clientId - !!a.clientId) || []);
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <FormGroup>
            <ControlLabel>
                <span>
                    Выбор шрифта текста
                    <HelpHintButton>
                        Настройка будет применена ко всем разделам платформы
                    </HelpHintButton>
                </span>
            </ControlLabel>
            <FormControl
                componentClass="select"
                name={THEME_FONT}
                value={font?.name || ''}
                onChange={(e) => onUpdate({[THEME_FONT]: e.target.value})}
            >
                <option value="">{STANDART_FONT}</option>
                {fontsList?.map((font) => (
                    <option
                        key={font?.id}
                        value={font?.name}
                    >
                        {font?.name}
                    </option>
                ))}
            </FormControl>
        </FormGroup>
    );
};

export default FontSettings;
